(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Quantity buttons
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v = Math.max(parseInt(input.min || '0', 10), v + parseInt(btn.dataset.step, 10));
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('.gallery__main img');
    if (!main) return;
    g.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.dataset.src;
        main.srcset = '';
        main.alt = t.dataset.alt || main.alt;
        g.querySelectorAll('[data-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });
  });

  // Variant picker
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var json = form.querySelector('[data-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var money = form.dataset.moneyFormat || '{{amount}}';
    var lowAt = parseInt(form.dataset.lowStock || '10', 10);
    var buttons = document.querySelectorAll('[data-buy-button]');

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(cents % 100 === 0 ? 0 : 2);
      return money.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    }
    function setAll(sel, fn) { document.querySelectorAll(sel).forEach(fn); }

    function update() {
      var selected = [];
      form.querySelectorAll('fieldset[data-option]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
        var label = fs.querySelector('[data-option-selected]');
        if (label && checked) label.textContent = checked.value;
      });
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      buttons.forEach(function (b) {
        if (!match) { b.disabled = true; b.querySelector('[data-label]').textContent = b.dataset.unavailable; return; }
        b.disabled = !match.available;
        b.querySelector('[data-label]').textContent = match.available ? b.dataset.add : b.dataset.soldout;
      });
      if (!match) return;
      idInput.value = match.id;
      setAll('[data-price]', function (el) { el.textContent = formatMoney(match.price); });
      setAll('[data-compare]', function (el) {
        el.textContent = match.compare > match.price ? formatMoney(match.compare) : '';
        el.hidden = !(match.compare > match.price);
      });
      setAll('[data-save]', function (el) {
        var on = match.compare > match.price;
        el.hidden = !on;
        if (on) el.textContent = el.dataset.prefix + ' ' + formatMoney(match.compare - match.price);
      });
      setAll('[data-stock]', function (el) {
        el.classList.remove('stock--low', 'stock--out');
        if (!match.available) { el.classList.add('stock--out'); el.textContent = el.dataset.out; }
        else if (match.tracked && match.qty > 0 && match.qty <= lowAt) { el.classList.add('stock--low'); el.textContent = el.dataset.low.replace('[n]', match.qty); }
        else { el.textContent = el.dataset.in; }
      });
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (e) {
      if (e.target.closest('fieldset[data-option]')) update();
    });
  });

  // Sticky buy bar: show when the main button is off screen
  var bar = document.querySelector('[data-buy-bar]');
  var mainBtn = document.querySelector('[data-main-buy]');
  if (bar && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(mainBtn);
  }
})();
